












import { Vue, Component, Prop } from 'vue-property-decorator';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
@Component({})
export default class CrearButton extends Vue {
  @Prop({
    default: () => ({
      accionCodigo: 0,
      visible: true,
      moduloCodigo: 0,
    }),
  })
  permisoAccion: PermisoAccion;
  handleClick() {
    this.$emit('click');
  }
}
